import { ClientIntakeFormItemsSelectors } from '@db-access/clientIntakeFormItems';
import { createSelector } from '@ngxs/store';
import {
	EngineFormItem,
	EngineFormItemType,
} from '@models/client-portal/engine-client-intake';

export class IntakeFormItemsSelectors {
	static readonly $intakeFormItems =
		ClientIntakeFormItemsSelectors._props.items;

	// Filter by type
	static readonly $sections = createSelector(
		[IntakeFormItemsSelectors.$intakeFormItems],
		(items: EngineFormItem[]) =>
			items.filter((item) => item.type === EngineFormItemType.SECTION),
	);

	static readonly $fields = createSelector(
		[IntakeFormItemsSelectors.$intakeFormItems],
		(items: EngineFormItem[]) =>
			items.filter((item) => item.type === EngineFormItemType.FIELD),
	);

	static readonly $subSections = createSelector(
		[IntakeFormItemsSelectors.$intakeFormItems],
		(items: EngineFormItem[]) =>
			items.filter((item) => item.type === EngineFormItemType.SUB_SECTION),
	);
}
